<template>
    <div class="course-item" ref="course">
        <router-link :to="getRouteToCourse(courseItem)" :class="['course-item__content', {'current': isCurrent }]" role="button" >
            <span class="icon-film1"></span>
            <div class="course-item__info">
                <span>
                    <span class="course-item__part"><span v-html="$t('CoursePreview.part')"></span> {{ index }}</span>
                    <span class="course-item__time"><span v-html="$t('CoursePreview.duration')"></span> {{ convertMinutesToHours(courseItem.videoDuration) }} </span>
                </span>
                <span class="course-item__title">{{ courseItem.title }}</span>
            </div>
        </router-link>
    </div>
</template>

<script>
    import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'
    import truncate from 'components/shared/mixins/truncate'
    import routeHelper from 'components/shared/mixins/routeHelper'
    export default {
        mixins: [ convertMinutesToHours, truncate, routeHelper ],
        props: {
            courseItem: Object,
            index: Number,
            isCurrent: {
                type: Boolean,
                default: false
            }
        },
        mounted () {
            if (this.isCurrent) {
                this.$store.dispatch('CoursesCollections/assignCollectionPreviewScrollTop', this.$refs.course.offsetTop)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .course-item {
        display: flex;
        flex-direction: column;
        font-size: 1.3rem;
        position: relative;
        color: $white;
        font-family: Quicksand-Regular, sans-serif;

        &__content {
            display: flex;
            padding: 15px 15px;
            background: $heavy_metal;
            position: relative;
            flex-direction: row;
            align-items: center;

            &.current,
            &.current:hover {
                @include white(background, 0.2);
            }

            &:hover {
                cursor: pointer;
                @include white(background, 0.1);
            }
        }

        &__info {
            display: flex;
            flex-direction: column;
            margin: 0 10px 0 0;
        }

        &__part {
            font-family: Quicksand-Bold, sans-serif;
            margin: 0 10px 0 0;
            color: $white;
        }

        &__time {
            color: $orange;
            margin: 0 10px 0 0;
            width: 100%;
            font-size: 1.2rem;        }

        [class*="icon-"] {
            color: $white;
            min-width: 42px;
            font-size: 1.8rem;
        }
        &__title {
            color: $white;
        }
    }
</style>
